export default __webpack_public_path__ + "static/300-340-eea1a3b097f67d89c68c3684bbee2026.jpg";